import { BaseEntity } from "@app/models/rest/base-entity";
import { PlanningSegment } from "@app/models/rest/planning-segment";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";
import { AutobookProfileType } from "@app/models/enums/autobook-profile-type.enum";

@HateoasResource("autoBookProfiles")
export class AutoBookProfile extends BaseEntity {
  description: string;
  initialPlanningDelay: number;
  workingDayLimit: number;
  maximumReservationUse: number;
  segments: PlanningSegment[];
  type: AutobookProfileType = AutobookProfileType.SLOT;
  instantBook: boolean = false;
}
